import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bd9b764"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "range-slider",
  ref: "slider"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-track" }, null, -1))
const _hoisted_3 = { class: "absolute top-0 left-0 text-white font-bold text-sm pt-[72px] whitespace-nowrap" }
const _hoisted_4 = { class: "absolute top-0 right-0 text-white font-bold text-sm pt-[72px] whitespace-nowrap" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "slider-range",
      style: _normalizeStyle({
        left: _ctx.leftPercent + '%',
        width: _ctx.rangePercent + '%'
      })
    }, null, 4),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("level_from_double_dot")) + " " + _toDisplayString(_ctx.localMin.toFixed(2)), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("level_to_double_dot")) + " " + _toDisplayString(_ctx.localMax.toFixed(2)), 1),
    (_ctx.showControls)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "thumb thumb-left",
            style: _normalizeStyle({ left: _ctx.leftPercent + '%' }),
            "data-thumb": "min",
            ref: "thumbMin",
            onPointerdown: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onStart && _ctx.onStart(...args)), ["prevent"]))
          }, null, 36),
          _createElementVNode("div", {
            class: "thumb thumb-right",
            style: _normalizeStyle({ left: _ctx.rightPercent + '%' }),
            "data-thumb": "max",
            ref: "thumbMax",
            onPointerdown: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onStart && _ctx.onStart(...args)), ["prevent"]))
          }, null, 36)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}